<template>
    <div class="cont">
        <p style="text-align: left; font-size: 250%; margin-top: 2vh; margin-bottom: 5vh; margin-left: 1vw; color: white; font-weight: bold;">{{ greetUser() }}</p>
        <transition name="fade" mode="out-in">
        <div v-if="madeForYou && madeForYou.length" class="hero-section">
           <div class="hero-image-container">
                <img :src="madeForYou[0]?.thumbnails?.maxres?.url || madeForYou[0]?.thumbnail"
                    class="hero-image">

               <div class="hero-overlay">
                     <p style="color: white; opacity: 0.8;">Song</p>
                    <div class="hero-content" v-if="madeForYou[0]?.title">
                        <h1 class="hero-title">
                            {{ madeForYou[0]?.title.split("(")[0].split("|")[0]}}
                        </h1>
                        <p v-if="madeForYou[0]?.artists" class="hero-artist">
                            {{ madeForYou[0].artists[0]?.name || madeForYou[0]?.artists || ''}}
                        </p>
                    </div>

                    <div class="hero-buttons">
                        <button
                            @click="handleHeroPlay(madeForYou[0])"
                            class="play-button"
                            @mouseenter="$event.target.style.backgroundColor = '#e5e5e5'"
                            @mouseleave="$event.target.style.backgroundColor = 'white'">
                            <v-icon :color="'black'" size="24">{{ queueStore.isPlayingTrack(madeForYou[0].videoId || madeForYou[0].video_id) && queueStore.isPlaying ? 'mdi-pause':'mdi-play' }}</v-icon>
                            <div v-if="queueStore.isPlayingTrack(madeForYou[0].videoId || madeForYou[0].video_id)" style="height: 100%; border: 0px solid red; display: flex; align-items: flex-end; width: 2vw;">
                                <MusicBar></MusicBar>
                            </div>
                            <span v-else class="play-text">Play</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <v-skeleton-loader class="custom-speed" v-else type="image" color="#80808027" height="30%"></v-skeleton-loader>
        </transition>

        <transition name="fade" mode="out-in">
        <div v-if="homeFeed.length" class="playlist-section">
            <p class="playlist-title">For You</p>
            <div
            class="scroll-wrapper"
            >
            <div ref="feedScroller" class="scroll-container">
                <div
                v-for="(item, index) in homeFeed"
                :key="item.videoId || item.id || item.video_id"
                style="border: 0px solid white; width: 11vw; border-radius: 20px; flex: 0 0 auto; scroll-snap-align: start;"
                :class="{'playing': queueStore.queue[queueStore.isPlayingIndex]?.id == (item.videoId || item.video_id)}"
                >
                <div class="card" @mouseenter="cardHoverIndex = ('feed-' + index)" @mouseleave="cardHoverIndex = null">
                    <img style="" :src="item.thumbnails?.standard?.url || item.thumbnail" draggable="false" />
                    <div v-if="cardHoverIndex == ('feed-' + index) || queueStore.queue[queueStore.isPlayingIndex]?.id == (item.videoId || item.video_id)" class="card-overlay">
                    <div class="card-button-container">
                        <button @click="playFeedTrack(item)" class="card-play-button">
                            <v-icon v-if="queueStore.isPlaying && queueStore.queue[queueStore.isPlayingIndex]?.id == (item.videoId || item.video_id)" color="black" size="small">mdi-pause</v-icon>
                            <v-icon v-else color="black" size="small">mdi-play-outline</v-icon>
                        </button>
                    </div>
                </div>
                </div>
                <p style="text-align: left; color: white; font-size: small; margin-top: 2vh; margin-left: 1.5vw; width: 8vw; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{ item.title?.split("(")[0] }}</p>
                <p style="text-align: left; color: white; font-size: x-small; margin-left: 1.5vw; margin-bottom: 1vw; text-transform: capitalize; width: 8vw; font-weight: lighter; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{item.artists[0]?.name?.toLowerCase() || item.artists?.toLowerCase() }}</p>
                </div>
            </div>
            </div>
        </div>
        <v-skeleton-loader class="custom-speed" v-else type="heading" color="#80808027" height="20vh"></v-skeleton-loader>
        </transition>

        <transition name="fade" mode="out-in">
        <div v-if="indiaPlaylist?.items?.items?.length" class="playlist-section">
            <p class="playlist-title">Top Songs India</p>
            <div class="scroll-wrapper">
            <div ref="scroller" class="scroll-container">
                <div
                v-for="(item, index) in indiaPlaylist?.items?.items"
                :key="item?.id"
                style="width: 23vw; flex: 0 0 auto; scroll-snap-align: start; border: 0px solid white; margin-top: 2vh;"
                >
                    <div style="position: relative; width: 90%; margin: auto;" @mouseenter="videoHoverIndex = ('videoFeed-' + index)" @mouseleave="videoHoverIndex = null">
                        <img
                            :src="item?.snippet?.thumbnails?.maxres?.url"
                            draggable="false"
                            style="width: 100%; margin: auto; display: block;"
                        />
                        <div v-if="videoHoverIndex == ('videoFeed-' + index) || queueStore.queue[queueStore.isPlayingIndex]?.id == item.snippet.resourceId.videoId" class="video-overlay">
                            <div class="video-button-container">
                                <button @click="playFeedTrack(item)" class="card-play-button">
                                    <v-icon v-if="queueStore.isPlaying && queueStore.queue[queueStore.isPlayingIndex]?.id == item.snippet.resourceId.videoId" color="black" size="small">mdi-pause</v-icon>
                                    <v-icon v-else color="black" size="small">mdi-play-outline</v-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <p style="color: white; font-size: small; text-align: left; margin-top: 1vh; width: 90%; margin-left: 5%;">{{ item?.snippet?.title }}</p>
                </div>
            </div>
            </div>
        </div>
        <v-skeleton-loader class="custom-speed" v-else type="heading" color="#80808027"  height="25vh"></v-skeleton-loader>
        </transition>

        <transition name="fade" mode="out-in">
        <div v-if="madeForYou.length" class="playlist-section">
            <p class="playlist-title">Made For You</p>
            <div
            class="scroll-wrapper"
            >
            <div ref="feedScroller" class="scroll-container">
                <div
                v-for="(item, index) in madeForYou"
                :key="item.videoId || item.id || item.video_id"
                style="border: 0px solid white; width: 11vw; border-radius: 20px; flex: 0 0 auto; scroll-snap-align: start;"
                :class="{'playing': queueStore.queue[queueStore.isPlayingIndex]?.id == (item.videoId || item.video_id)}"
                >
                <div class="card"  @mouseenter="cardHoverIndex = ('feed2-' + index)" @mouseleave="cardHoverIndex = null">
                    <img :src="item.thumbnails?.standard?.url || item.thumbnail" draggable="false" />
                    <div v-if="cardHoverIndex == ('feed2-' + index) || queueStore.queue[queueStore.isPlayingIndex]?.id == (item.videoId || item.video_id)" class="card-overlay">
                    <div class="card-button-container">
                        <button @click="playFeedTrack(item)" class="card-play-button">
                            <v-icon v-if="queueStore.isPlaying && queueStore.queue[queueStore.isPlayingIndex]?.id == (item.videoId || item.video_id)" color="black" size="small">mdi-pause</v-icon>
                            <v-icon v-else color="black" size="small">mdi-play-outline</v-icon>
                        </button>
                    </div>
                </div>
                </div>
                <p style="text-align: left; color: white; font-size: small; margin-top: 2vh; margin-left: 1.5vw; width: 10vw; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">{{ item.title }}</p>
                <p style="text-align: left; color: white; font-size: x-small; margin-left: 1.5vw; margin-bottom: 1vw; text-transform: capitalize; width: 10vw; font-weight: lighter; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{item.artists[0]?.name?.toLowerCase() || item.artists?.toLowerCase() }}</p>
                </div>
            </div>
            </div>
        </div>
        <v-skeleton-loader class="custom-speed" v-else type="heading" color="#80808027"  height="20vh"></v-skeleton-loader>
        </transition>

        <transition name="fade" mode="out-in">
            <div v-if="globalPlaylist?.items?.items?.length" class="playlist-section">
                <p class="playlist-title">Top Global</p>
                <div
                class="scroll-wrapper"
                >

                
                <div ref="scroller" class="scroll-container">
                    <div
                    v-for="(item, index) in globalPlaylist?.items?.items"
                    :key="item?.id"
                    style="width: 23vw; flex: 0 0 auto; scroll-snap-align: start; border: 0px solid white; margin-top: 2vh;"
                    >
                        <div style="position: relative; width: 90%; margin: auto;" @mouseenter="videoHoverIndex = ('videoFeed2-' + index)"
                    @mouseleave="videoHoverIndex = null">
                            <img
                                :src="item?.snippet?.thumbnails?.maxres?.url"
                                draggable="false"
                                style="width: 100%; margin: auto; display: block;"
                            />
                            <div v-if="videoHoverIndex == ('videoFeed2-' + index) || queueStore.queue[queueStore.isPlayingIndex]?.id == item.snippet.resourceId.videoId" class="video-overlay">
                                <div class="video-button-container">
                                    <button @click="playFeedTrack(item)" class="card-play-button">
                                        <v-icon v-if="queueStore.isPlaying && queueStore.queue[queueStore.isPlayingIndex]?.id == item.snippet.resourceId.videoId" color="black" size="small">mdi-pause</v-icon>
                                        <v-icon v-else color="black" size="small">mdi-play-outline</v-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <p style="color: white; font-size: small; text-align: left; margin-top: 1vh; width: 90%; margin-left: 5%;">{{ item?.snippet?.title }}</p>
                    </div>
                </div>
                </div>
            </div>
            <v-skeleton-loader class="custom-speed" v-else type="heading" color="#80808027"  height="25vh"></v-skeleton-loader>
        </transition>

        <div style="height: 10vh;"></div>

        <br>
        <br>
    </div>
</template>
<script>
import { useToast } from 'vue-toastification';
import { useQueueStore } from '../stores/queue.js';
import { useUserStore } from '../stores/user.js';
import { EventBus } from '../eventBus.js';
import { computed } from 'vue';
import { useFeedStore } from '../stores/feed.js';
import MusicBar from './MusicBar.vue';

export default {
    name: "HomeComponent",
    setup() {
        const queueStore = useQueueStore();
        const userStore = useUserStore();
        const feedStore = useFeedStore();
        const user = computed(() => queueStore.userData);
        return {queueStore, user, userStore, feedStore};
    },
    components:{
        MusicBar
    },
    data(){
        return{
            toast: useToast(),
            prodUrl: process.env.VUE_APP_PROD_URL,
            genres: ['Romance', 'Workout', 'Feel good', 'Party', 'Relax', 'Energize', 'commute', 'sleep', 'sad', 'Focus'],
            selectedGenre: '',
            songs: [],
            isLoading: false,
            loadingUserInfo: false,
            hoveredIndex: null,
            indiaPlaylist: {},
            globalPlaylist: {},
            heroSongInfo: {},
            showArrows: false,
            showArrowsGlobal: false,
            cardHoverIndex: null,
            videoHoverIndex: null,
            homeFeed: [],
            madeForYou: this.feedStore.madeForYou || [],
        }
    },
    beforeMount(){
        this.fetchMadeForYou().then(() => {
            EventBus.emit('update-background', this.madeForYou[0]?.thumbnail);
        });
        this.fetchGlobalPlaylist();
    },
    methods:{
        greetUser() {
            const hour = new Date().getHours();

            const userName = this.userStore.user?.name
                ?.split(" ")[0];

            const name = userName
                ? userName.charAt(0).toUpperCase() + userName.slice(1)
                : null;

            const greetings = {
                        morning: {
                            loggedIn: [
                                `Good morning, ${name}`,
                                `Morning, ${name}`,
                                `Rise and shine, ${name}`,
                                `Morning vibes, ${name}`,
                                `Fresh start, ${name}`,
                                `Morning, music awaits`,
                            ],

                            loggedOut: [
                                `Good morning`,
                                `Morning vibes 🎧`,
                                `Rise and shine`,
                                `Fresh morning, fresh music`,
                                `Morning, music awaits`,
                                `Start your morning with some music`,
                            ],
                        },

                        afternoon: {
                            loggedIn: [
                                `Good afternoon, ${name}`,
                                `Afternoon, ${name} 🎧`,
                                `Hey ${name}, welcome back`,
                                `Afternoon vibes, ${name}`,
                                `Keep going, ${name}`,
                                `Music time, ${name}`,
                            ],

                            loggedOut: [
                                `Good afternoon`,
                                `Afternoon vibes 🎧`,
                                `Hey, welcome`,
                                `Take a break, play something`,
                                `Music time`,
                                `Find something to listen to`,
                            ],
                        },

                        evening: {
                            loggedIn: [
                                `Good evening, ${name}`,
                                `Evening, ${name}`,
                                `Hey ${name}, welcome back`,
                                `Evening vibes, ${name}`,
                                `Time to unwind, ${name}`,
                                `Night tunes, ${name}`,
                            ],

                            loggedOut: [
                                `Good evening`,
                                `Evening vibes 🎧`,
                                `Time to unwind`,
                                `What's playing tonight?`,
                                `Find your evening soundtrack`,
                                `Set the mood with some music`,
                            ],
                        },
                    };

            let period;

            if (hour < 12) {
                period = 'morning';
            } else if (hour < 18) {
                period = 'afternoon';
            } else {
                period = 'evening';
            }

            const isLoggedIn = !!this.userStore.user?.name

            const options = isLoggedIn
                ? greetings[period].loggedIn
                : greetings[period].loggedOut;

            return options[
                Math.floor(Math.random() * options.length)
            ];
        },
        async fetchPlaylist(){
            if(this.feedStore.indiaPlaylist.length){
                if(!this.indiaPlaylist?.length){
                    this.indiaPlaylist = this.feedStore.indiaPlaylist;
                }
                return
            }
            try {
                const res = await fetch(`${this.prodUrl}/music/playlist/PL4fGSI1pDJn5oibdgJt8Hy0-dr2B7kSs2`);
                const data = await res.json();
                this.indiaPlaylist = data;
                this.feedStore.setIndiaPlaylist(data);
            } catch (error) {
                console.error(error);
                this.toast.error('Error fetching playlist');
            }
        },
        async fetchGlobalPlaylist(){
            if(this.feedStore.globalPlaylist.length){
                if(!this.globalPlaylist.length){
                    this.globalPlaylist = this.feedStore.globalPlaylist;
                }
                return;
            }
            try {
                const res = await fetch(`${this.prodUrl}/music/playlist/PL4fGSI1pDJn6t3TXLGiiJdD-sZbrG3tG0`);
                const data = await res.json();
                this.globalPlaylist = data;
                this.feedStore.setGlobalPlaylist(data);
            } catch (error) {
                console.error(error);
                this.toast.error('Error fetching playlist');
            }
        },
        async searchPlaylist(query){
            this.isLoading = true;
            try {
                const res = await fetch(`${this.prodUrl}/music/search/playlist?q=${query}`);
                const data = await res.json();
                this.isLoading = false;
                return data;
            } catch (error) {
                console.error(error);
                this.isLoading = false;
                this.toast.error('Error fetching playlist');
                return null;
            }
        },
        searchGenreSong(query){
            if (!query || !query.length) {
                query = 'trending in';
            }
            this.isLoading = true;
            fetch(`${this.prodUrl}/music/getQueue?query=${query} india`).then(
                async(res) => {
                    this.isLoading = false;
                    res = await res.json();
                    this.songs = res;
                }
            )
            .catch((err) => {
                console.log(err);
                this.isLoading = false;
                this.toast.error('Something went wrong while getting results')
            });
        },
        play(id, title, snippet){
            if(this.queueStore.queue[this.queueStore.isPlayingIndex]?.id !== id){
                EventBus.emit('play_track', {id, title, snippet});
            }
        },
        togglePlayPause(track){
            if(!this.queueStore.queue.length || this.queueStore.queue[this.queueStore.isPlayingIndex]?.id !== track.id){
                EventBus.emit('play_track', track);
                return;
            }
            if(this.queueStore.isPlaying){
                EventBus.emit('pause');
            } else {
                EventBus.emit('play');
            }
        },
        async fetchHomeFeed(){
            if(this.feedStore.homeFeed.length){
                if(!this.homeFeed.length) {
                    this.homeFeed = this.feedStore.homeFeed;
                    console.log(this.homeFeed)
                }
                return;
            }
            try {
                const res = await fetch(`${this.prodUrl}/user/homeFeed`, { credentials: 'include' }).then((r) => r.json());
                this.homeFeed = res.data?.feed || [];
                this.feedStore.setHomeFeed(this.homeFeed);
            } catch (error) {
                console.error(error);
            }
        },
        async fetchMadeForYou(){
            EventBus.emit('update-background-home', this.madeForYou[0]?.thumbnail);
            if (this.madeForYou.length) return;
            try {
                const res = await fetch(`${this.prodUrl}/user/madeForYou`, { credentials: 'include' }).then((r) => r.json());
                this.madeForYou = res.data?.songs || [];
                EventBus.emit('update-background', this.madeForYou[0]?.thumbnail);
            } catch (error) {
                console.error(error);
            }
        },
        playFeedTrack(track){
            const videoId = track.snippet?.resourceId?.videoId || track.videoId || track.id || track.video_id;
            if(this.queueStore.queue[this.queueStore.isPlayingIndex]?.id == videoId){
                this.queueStore.isPlaying ? EventBus.emit('pause'):EventBus.emit('play');
            } else if (this.queueStore.queue[this.queueStore.isPlayingIndex]?.id !== videoId) {
                this.queueStore.emptyQueue();
                this.queueStore.play();
                this.queueStore.isPlayingIndex = 0;
                this.queueStore.isPlaying = false;
                EventBus.emit('play_track', { ...track, id: videoId, title: track.title });
            }
        },
        scrollLeft(scrollerRef){
            this.$refs[scrollerRef].scrollBy({
                left: -300,
                behavior: 'smooth'
            });
        },
        scrollRight(scrollerRef) {
            this.$refs[scrollerRef].scrollBy({
                left: 300,
                behavior: 'smooth'
            });
        },
        handleHeroPlay(track){
            if(track.videoId){
                track.id = track.videoId
            }
            if(track.video_id){
                track.id = track.video_id;
            }
            if(this.queueStore.isPlayingTrack(track.id)){
                if(this.queueStore.isPlaying){
                    EventBus.emit('pause');
                } else {
                    EventBus.emit('play');
                }
            } else {
                if(!this.queueStore.isPlayingTrack(track.id)){
                    EventBus.emit('play_track', track);
                }
            }
        }
    },
    mounted(){
        this.fetchHomeFeed();
        this.fetchMadeForYou();
        this.fetchPlaylist();
    },
    watch: {
        selectedGenre(newVal) {
            this.searchGenreSong(newVal);
        },
    },
}
</script>

<style scoped>
.cont {
    width: 100%;
    /* mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 15%);
    -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 15%); */
    scrollbar-width: none;
    scrollbar-color: transparent transparent;
    overflow-y: auto;
    height: 100%;
    border: 0px solid green;
    border-radius: 14px;
}

/* .cont::-webkit-scrollbar {
    display: none;
} */

/* Hero Section */
.hero-section {
    overflow: hidden;
    position: relative;
    border-radius: 0 0 15px 15px;
    /* width: 100%;
    aspect-ratio: 4/3; */
}

.hero-image-container {
    position: relative;
    width: 100%;
    height: 50vh;
    max-height: 50vh;
    overflow: hidden;
    border-radius: 30px;
}

.hero-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;

    /* -webkit-mask-image: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.05) 0%,
        rgba(0, 0, 0, 0.05) 10%,
        rgba(0, 0, 0, 0.15) 25%,
        rgba(0, 0, 0, 0.45) 45%,
        rgba(0, 0, 0, 0.75) 60%,
        black 75%
    );

    mask-image: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.05) 0%,
        rgba(0, 0, 0, 0.05) 10%,
        rgba(0, 0, 0, 0.15) 25%,
        rgba(0, 0, 0, 0.45) 45%,
        rgba(0, 0, 0, 0.75) 60%,
        black 75%
    ); */
}

.hero-overlay {
    position: absolute;
    inset: 0;
    padding: 4vh 4vw;

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;

    box-sizing: border-box;
}

.hero-content {
    margin-bottom: 2vh;
}

.hero-title {
    color: white;
    font-size: 2.5rem;
    font-weight: bold;
    margin: 0 0 0.5rem 0;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
    line-height: 1.2;
    text-align: left;
}

.hero-artist {
    text-align: left;
    color: #e5e5e5;
    font-size: 1.1rem;
    margin: 0;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
}

.hero-buttons {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.play-button {
    border: 0;
    background-color: white;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    cursor: pointer;
    transition: background-color 0.2s;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    height: 5vh;
    min-width: 8vw;
}

.play-button:hover {
    opacity: 0.8;
}

.play-text {
    font-weight: bold;
    color: black;
    font-size: 1.1rem;
}

/* Playlist Section */
.playlist-section {
    margin-top: 1vh;
}

.playlist-title {
    font-weight: bold;
    color: white;
    width: fit-content;
    font-size: xx-large;
    /* margin-left: 1.5vw; */
    line-height: 1.7rem;
    margin-top: 7vh;
}

.scroll-wrapper {
    position: relative;
    border: 0px solid yellow;
}

.scroll-container {
    display: flex;

    width: 100%;
    min-width: 0;
    max-width: 100%;

    gap: 0.7rem;

    overflow-x: scroll;
    overflow-y: hidden;

    scroll-snap-type: x mandatory;

    padding: 0.5rem 0;

    scrollbar-width: none;
}

.scroll-container::-webkit-scrollbar {
    display: block;
}

.card {
    width: 80%;
    aspect-ratio: 1 / 1;
    margin: auto;
    margin-top: 1.2vw;
    position: relative;
    border-radius: 20px;
    overflow: hidden;
}

.card img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    pointer-events: none;
    transform: scale(1.4);
}

.playing{
    background-color: #fc2c55;
}

/* .card img {
    width: 100%;
    display: block;
    pointer-events: none;
} */

.card-overlay {
    position: absolute;
    inset: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    background: rgba(0, 0, 0, 0.45);

    border-radius: inherit;
}

.video-overlay{
    position: absolute;
    inset: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    background: rgba(0, 0, 0, 0.45);

    border-radius: inherit;
}

.card-button-container {
    display: flex;
    align-items: center;
    justify-content: center;
}

.card-play-button {
    width: 52px;
    height: 52px;
    min-width: 52px;

    padding: 0;
    border: none;
    border-radius: 50%;

    background: #000;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    transition:
        transform 0.2s ease,
        background-color 0.2s ease;
}

.video-play-button {
    width: 52px;
    height: 52px;
    min-width: 52px;

    padding: 0;
    border: none;
    border-radius: 50%;

    background: #000;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;

    transition:
        transform 0.2s ease,
        background-color 0.2s ease;
}

.card-play-button:hover, .video-play-button:hover {
    background: #111;
}

.card-play-button .v-icon,.video-play-button .v-icon {
    color: white !important;
}
.card-play-text {
    font-size: small;
    color: black;
    margin: 0;
}

.card-title {
    font-size: small;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: white;
    padding: 0 0.5rem 0.5rem;
    margin: 0;
    text-align: right;
}

/* Arrows */
.arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(0, 0, 0, 0.6);
    color: white;
    border-radius: 50%;
    padding: 6px;
    cursor: pointer;
    z-index: 10;
    transition: opacity 0.2s ease;
}

.arrow.left {
    left: 5px;
}

.arrow.right {
    right: 5px;
}

.arrow:hover {
    background: rgba(0, 0, 0, 0.85);
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-leave-to, .fade-enter-from {
    opacity: 0;
}

.fade-enter-to, .fade-leave-from {
    opacity: 1;
}

.custom-speed :deep(.v-skeleton-loader__bone::after) {
  animation-duration: 5s !important; /* Default is usually 1.5s to 2s */
}

.crop{
    display: none;
}

/* Tablet (768px and below) */
@media only screen and (max-width: 768px) {
    .hero-overlay {
        width: 60%;
        padding: 3vh 4vw;
    }

    .hero-title {
        font-size: 2rem;
    }

    .hero-artist {
        font-size: 1rem;
    }

    .play-button {
        padding: 0.7rem 1.5rem;
    }

    .play-text {
        font-size: 1rem;
    }

    .playlist-title {
        font-size: x-large;
    }

    .card {
        width: min(60vw, 200px);
    }
}

/* Mobile (480px and below) */
@media only screen and (max-width: 480px) {
    .hero-overlay {
        width: 100%;
        background: linear-gradient(to top, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0.7) 50%, transparent 100%);
        padding: 2vh 5vw;
        align-items: center;
        height: auto;
        bottom: 0;
    }

    .hero-content {
        margin-bottom: 1.5vh;
        width: 100%;
    }

    .hero-title {
        font-size: 1.5rem;
        text-align: center;
    }

    .hero-artist {
        font-size: 0.9rem;
        text-align: center;
    }

    .hero-buttons {
        width: 100%;
        justify-content: center;
    }

    .play-button {
        padding: 0.6rem 1.2rem;
        width: auto;
    }

    .play-text {
        font-size: 0.9rem;
    }

    .playlist-title {
        font-size: large;
        padding: 0 0.5rem;
    }

    .card {
        width: min(50vw, 150px);
    }

    .card-play-button {
        width: 35%;
        min-width: 50px;
    }

    .card-play-text {
        font-size: x-small;
    }

    .arrow {
        padding: 4px;
    }

    .arrow.left {
        left: 2px;
    }

    .arrow.right {
        right: 2px;
    }
}

/* Small Mobile (360px and below) */
@media only screen and (max-width: 360px) {
    .hero-title {
        font-size: 1.2rem;
    }

    .hero-artist {
        font-size: 0.8rem;
    }

    .play-button {
        padding: 0.5rem 1rem;
    }

    .play-text {
        font-size: 0.85rem;
    }

    .playlist-title {
        font-size: medium;
    }

    .card {
        width: min(45vw, 130px);
    }
}

/* Landscape Mobile */
@media only screen and (max-height: 500px) and (orientation: landscape) {
    .hero-overlay {
        padding: 2vh 3vw;
    }

    .hero-title {
        font-size: 1.3rem;
    }

    .hero-artist {
        font-size: 0.85rem;
    }

    .hero-content {
        margin-bottom: 1vh;
    }

    .play-button {
        padding: 0.5rem 1rem;
    }
}
</style>